module.exports = __webpack_public_path__ + "64701561f9283988b6bb1080a68f9435.pdf";